<template>
<div class="chapter">
<div class="inner_page">
<blockquote>
<p class="sectiontop">“. . . and leave you, (inexpressibly to unravel)<br/>
    your life, with its immensity and fear,<br/>
    so that, now bounded, now immeasurable,<br/>
    it is alternately stone in you and star.”</p>
<p class="att_left">Rainer Maria Rilke<br/>
    translated by Stephen Mitchell<a id="page_iii"></a></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_fm02.vue?5e4ffbb1